// Style Global
import '@/styles/global.css';

// Material Design
import '@mdi/font/css/materialdesignicons.css';

// Vue
import App from './App.vue';
import { createApp } from 'vue';
const app = createApp(App);

// Router
import { router } from './router';
app.use(router);

// Vuetify
import vuetify from './plugins/vuetify';
app.use(vuetify);

// Pinia
import { createPinia } from 'pinia';

const pinia = createPinia();
app.use(pinia);

app.mount('#app');

/**
 * Gualter: Informativos do projeto apresentados no console
 * - O objetivo e ter a certificação da versão que está no cliente
 */
console.groupCollapsed(`🚀 App Info: ${__VERSAO_PROJETO__}`);
console.log('🕒 Build Time:', __HORARIO_BUILD__);
console.log('🔖 Commit:', __COMMIT_HASH__);
console.log('🌿 Branch:', __GIT_BRANCH__);
console.groupEnd();
